@if (messagePassed) {
  <div class="errorMsgContainer">
    <div class="error-message-icon"><img [src]="timeoutErrorIcon" /></div>
    <div class="main-msg">We couldn't complete your request</div>
    <div class="secondary-msg">
      The system timed out. Refresh the page and try again. <br />
      If you still get this message, refine your search.
    </div>
  </div>
} @else {
  <div class="noResultMsgContainer">
    <div class="noResultWarning-icon"><img [src]="noResultIcon" /></div>
    <div class="main-msg">No results to show</div>
    <div class="secondary-msg">Please try another search or change your filters.</div>
  </div>
}
